import * as React from "react";
import { useDispatch } from "react-redux";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import { Link } from "react-router-dom";

import { resetPassword } from "./../slices/auth";
import { canopy } from "./../theme";
import AuthLayout from "./AuthLayout";

export default function Reset() {
  const dispatch = useDispatch();
  const handleSubmit = (event) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    dispatch(
      resetPassword({
        email: data.get("email"),
      }),
    );
  };

  return (
    <AuthLayout subtitle="Reset your password">
      <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 4 }}>
        <Stack spacing={2}>
          <Typography sx={{ fontSize: 14, color: "text.secondary", fontWeight: 600 }}>
            Enter the email for your account and we'll send you a link to reset
            your password.
          </Typography>
          <TextField
            required
            fullWidth
            id="email"
            label="Email address"
            name="email"
            autoComplete="email"
            autoFocus
          />
          <Button type="submit" fullWidth variant="contained" size="large">
            Send reset link
          </Button>
        </Stack>
        <Stack alignItems="center" sx={{ mt: 3 }}>
          <Link
            to="/signin"
            style={{ color: canopy.green, fontWeight: 800, fontSize: 14, textDecoration: "none" }}
          >
            Back to sign in
          </Link>
        </Stack>
      </Box>
    </AuthLayout>
  );
}
